import { BaseStore } from "stores/base_store";
import { runInAction, makeAutoObservable } from "mobx";
import { api_get, api_post } from "api/utils";


type StripeInvoiceType = {
    payment_intent: string;
    status: string;
};

export type RefundPaymentType = {
    identity: string;
    payment_uuid: string;
    payment_intent_id: string;
    reason: string;
};


export type PaymentProps = {
    key: string;
    refunded: boolean;
    status: string;

    minutes_included: number;
    tasks_included: number;
    tasks_used: number;
    tasks_expire: string;
    stripe_invoice_id: string;
    stripe_subscription_id: string;
    invoice_json: StripeInvoiceType;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: PaymentProps) => void;
};

// Domain object Payment
export class Payment implements PaymentProps {
    key = "";
    refunded = false;
    status = "";
    minutes_included = 0;
    tasks_included = 0;
    tasks_used = 0;
    tasks_expire = "";
    stripe_invoice_id = "";
    stripe_subscription_id = "";
    invoice_json = { payment_intent: "", status: "" } as StripeInvoiceType;

    date_created = "";
    date_updated = "";

    constructor(attributes: PaymentProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: PaymentProps) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class PaymentStore extends BaseStore<PaymentProps, Payment> {

    // async fetchList(userKey: string, cursor = "") {
    //     // Autogenerated
    //     return PaymentAPI.list(userKey, cursor).then((resp) => {
    //         this.receiveUpdate(resp.items);
    //         if (resp.cursor) {
    //             this.fetchList(userKey, resp.cursor);
    //         }
    //         // This returns as possibly incomplete list due to the cursor,
    //         // but PaymentStore.items is complete when .then() is called
    //         // so you can/should just use that.
    //         return resp.items;
    //     })
    // }

    async fetch(uuid: string) {
        const response = await api_get(`/payment?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        return null;
    }


    async fetchForSupport(uuid: string) {
        const response = await api_get(`/payment/support-fetch?uuid=${uuid}`);
        if(response.ok) {
            const data = await response.json();
            return data;
        }
        return null;
    }

    async listForSupport(identity: string, userUuid: string, cursor: string = '') {
        const data = { user_uuid: userUuid,
            identity: identity,
            cursor: cursor };
        const response = await api_get('/payment/support-list', data);
        if(response.ok) {
            const data = await response.json();
            return data;
        }
        return null;
    }


    async supportRefundPayment(refundPayment: RefundPaymentType) {
        console.log('refundPayment', refundPayment);
        const response = await api_post('/payment/support-refund', refundPayment);
        if(response.ok) {
            const data = await response.json();
            return data;
        }
        return null;
    }


    modelConstructor() {
        return Payment;
    }

}
